import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3134, { U3134ROLES } from "./U3134";
import U3134WorkInProgressList from "./components/list/U3134WorkInProgressList";
import U3134WorkInProgressForm from "./components/form/U3134WorkInProgressForm";
import U3134TecAgeReportPage from "./components/report/U3134TecAgeReportPage";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3134Routes: RouteObject[] = [
  {
    path: "U3134",
    element: <U2000RequireRole allowedRoles={[U3134ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3134 />,
        children: [
          { index: true, element: <U3134WorkInProgressList /> },
          { path: "reports/tec-age", element: <U3134TecAgeReportPage /> },
          { path: ":id", element: <U3134WorkInProgressForm /> },
        ],
      },
    ],
  },
];

export default U3134Routes;
